const func = $target => {
	var gutter = 30,
		height,
		headerHeight,
		padding;

	$(window)
		.on('resize', function() {
			height = $target.height();
			headerHeight = $('header').height() + gutter;
			padding = $target.parents('section').css('padding-bottom');
			$target.css('top', headerHeight);
			if (height > $(window).height() - headerHeight - parseFloat(padding)) {
				$target.css('top', 'calc(100vh - (' + height + 'px + ' + padding + '))');
			}
		})
		.trigger('resize');

	$target.find('form .card').each(function() {
		var $this = $(this);

		$this
			.find('input[type="number"]')
			.on('change keyup', function(e) {
				if (this.value > 0) {
					$this.addClass('active');
				} else {
					$this.removeClass('active');
				}
				updateAddBtn();
			})
			.trigger('change');
	});

	function updateAddBtn() {
		var disable = true;
		$target.find('form .card input[type="number"]').each(function() {
			if (this.value > 0) {
				disable = false;
			}
		});
		$target.find('form button[type="submit"]').prop('disabled', disable);
	}
};

export default func;
